import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/article-content';

const categoryIconMap: Record<string, string> = {
  'guides.category.guide': 'ri-book-open-line',
  'guides.category.review': 'ri-chat-quote-line',
  'guides.category.shipping': 'ri-truck-line',
};

export default function GuidesSection() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || 'en').split('-')[0] as 'en' | 'pl' | 'es' | 'fr';

  return (
    <section id="guides" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">{t('guides.title')}</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">{t('guides.subtitle')}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((article) => {
            const meta = article.meta[lang] || article.meta.en;
            const icon = categoryIconMap[article.categoryKey] || 'ri-file-text-line';
            return (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-400"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                    <i className={`${icon} text-lg`} />
                  </span>
                  <span className="inline-flex items-center rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
                    {t(article.categoryKey)}
                  </span>
                </div>
                <h3 className="mt-4 text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  {meta.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {meta.description}
                </p>
                <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500">
                  <span>{t('guides.updated')} {article.updatedDate}</span>
                  <span>{article.readingTime} {t('guides.minRead')}</span>
                </div>
                <span className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
                  {t('common.readMore')}
                  <i className="ri-arrow-right-line text-sm" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}